import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as Error } from '@/assets/svgs/icon-error-message-exclamation.svg';
import { ReactComponent as IconInfoBusiness } from "@/assets/svgs/my-info-business.svg";
import Button from "@/components/Button";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import googleKeys from "@/constants/configuration/google-keys.json";
import countries from "@/constants/country";
import useModal from '@/hooks/use-modal';
import useMyInfo from "@/hooks/use-my-info/index";
import { NavLink, useQuery } from "@/lib/router-dom";
import API_CONFIG from '@/services/api/config.js';
import API_LOGIN from "@/services/api/login";
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import { uniqueId } from 'lodash';
import moment from "moment";
import PropTypes from "prop-types";
import { useEffect, useMemo, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Appointment from "./components/appointments";
import CompanyInfo from "./components/company-info";
import MyinfoBusinessCard from "./components/my-info-business";
import PersonalInfo from "./components/personal-info";

import API_ENROLL from "@/services/api/myenrol.js";
import useToast from "@/hooks/use-toast";
import Portal from '@/components/Portal/index';

let baseUrl = window.location.origin

const BuildexSignup = ({
	register,
	errors,
	trigger,
	isValid,
	loading,
	setValue,
	watch,
	handleSubmit,
	loginHandler,
	control,
	reset
}) => {

	const { env, dex } = getEnvAndDex();

	const defaultCaptchaValue = googleKeys?.[dex]?.[env]?.CAPTCHA_SITE_KEY;
	const [captchaToken, setCaptchaToken] = useState(!defaultCaptchaValue);
	const [pitstopHost, setPitstopHost] = useState("");
	const [defaultDomain, setDefaultDomain] = useState("");
	const [errorMessage, setErrorMessage] = useState();

	const [myInfoBizAppointmentList, setMyInfoBizAppointmentList] = useState([]);
	const [isFilledWithMyInfo, setIsFilledWithMyInfo] = useState(false)
	const [isLoadingMyInfo, setIsLoadingMyInfo] = useState(false)
	const [appointmentIdSelected, setAppointmentIdSelected] = useState("");
	const [currentMyInfoProfile, setCurrentMyInfoProfile] = useState({
		email: "",
		fullName: "",
		mobileNumber: "",
		organization: {}
	})

	const [personalInfo, setPersonalInfo] = useState({
		mobileCountryCode: {
			id: "SG",
			label: "SINGAPORE +65",
			cc: "+65",
		}
	});
	const [companyInfo, setCompanyInfo] = useState({
		dateOfIncorporation: null
	})
	const [appointmentInfo, setAppointmentInfo] = useState({
		mobileCountryCode: {
			id: "SG",
			label: "SINGAPORE +65",
			cc: "+65"
		},
	})

	const {	visible: visibleAppointmentSelection, show: showAppointmentSelection, hide: hideAppointmentSelection} = useModal();
	const { fetch: fetchMyInfo, currentItem: myInfoItem } = useMyInfo();
	const { visible: isShowMyInfoModal, show: showMyInfoConfimModal, hide: hideMyInfoConfirmModal } = useModal();
	const { addToastMessage } = useToast();
	const captchaRef = useRef(null);
	const stateID = uniqueId();
	const query = useQuery();
	const authCodeQueryparams = query.get("code");

	useEffect(() => {
		const fetchConfig = async () => {
			const defaultHost = (await API_CONFIG.index())[1];
			setPitstopHost(defaultHost?.pitstopHost);
			setDefaultDomain(defaultHost?.pitstopHost?.split('{{SystemShortName}}')[1]);
		}

		fetchConfig();
		fetchMyInfo();
	}, [])

	useEffect(() => {
		async function getData() {
			window.history.replaceState(null, "", "/sign-up");
			getEntityData()
		}
		if (authCodeQueryparams !== null) {
			getData()
		}
	}, [authCodeQueryparams])

	const countryCodes = useMemo(() => {
		return countries.map((country) => ({
			id: country.value,
			label: `${country.name} ${country.cc}`,
			cc: country.cc,
		}));
	}, [countries]);

	const infoItems = useMemo(() => {
		if (myInfoItem) {
			return {
				companyType: myInfoItem.companyTypes?.map(item => ({id: item.value, label: item.name})),
				countryOfIncorp: myInfoItem.countryOfIncorp?.map(item => ({id: item.value, label: item.name})),
				nationality: myInfoItem.nationality?.map(item => ({id: item.value, label: item.name})),
				appointmentTitle: myInfoItem.companyAppointment?.map(item => ({id: item.value, label: item.name})),
				authRedirectUrl: myInfoItem?.authRedirectUrl,
			}
		}
	}, [myInfoItem])


	async function handleChangeReCaptcha(value) {
		const [error] = await API_LOGIN.siteVerify({ token: value });
		if (error) {
			setCaptchaToken(false);
			if (captchaRef.current) {
				captchaRef.current.reset();
			}
			return setErrorMessage("reCAPTCHA verification failed")
		}
		setCaptchaToken(true);
	}

	const setFormValue = (key, value) => {
		setValue(key, value ?? "", { shouldValidate: true });
	};

	const getEntityData = async () => {
		setIsLoadingMyInfo(true);
		const params = "authCode=" + authCodeQueryparams + `&callbackUrl=${baseUrl}/sign-up`;
		const [error, result] = await API_ENROLL.getRequestParams(params);
		setIsLoadingMyInfo(false)
		if(error) {
			return addToastMessage(error?.message, "error");
		}
		setIsFilledWithMyInfo(true);
		let infoBizData = {};
		Object.keys(result).forEach((key) => {
			infoBizData[key] = result[key];
		});
		const appointmentArray = result.entity["appointments"]["appointments-list"];
		const appointments = appointmentArray.filter(item => item["person-reference"]?.idno)
		setMyInfoBizAppointmentList(appointments);
		fillMyInfoDetails(infoBizData, appointments);
	}

	const fillMyInfoDetails = (infoBizData, appointmentArray) => {

		// Fill form details
		const basic_profile = infoBizData.entity["basic-profile"];
		const address = infoBizData.entity.addresses["addresses-list"][0];
		const addressDetails = [ address.building?.value, address.floor?.value, address.block?.value, address.street?.value, address.country?.desc, address.postal?.value].filter(Boolean).join(" ");
		const company = basic_profile["entity-name"].value;
		const uen = basic_profile.uen.value;
		const registeredAddress = addressDetails;
		const dateOfIncorporation = new Date(basic_profile["registration-date"].value)

		const countryOfIncorporation =  basic_profile["country-of-incorporation"]
		const companyType = basic_profile["company-type"] ? basic_profile["company-type"] : basic_profile["business-constitution"]

		setFormValue("company", company)
		setFormValue("countryOfIncorporation", countryOfIncorporation?.code)
		setFormValue("companyType", companyType?.code)
		setFormValue("uen", uen)
		setFormValue("registeredAddress", registeredAddress)

		setCompanyInfo({
			dateOfIncorporation: dateOfIncorporation,
			countryOfIncorporation: countryOfIncorporation?.desc,
			companyType: companyType?.desc
		});
		setCurrentMyInfoProfile(prev => ({
			...prev,
			fullName: infoBizData.person?.name.value,
			organization: {
				...prev.organization,
				name: basic_profile["entity-name"].value,
				uen: basic_profile.uen.value,
				registeredAddress: addressDetails,
				countryOfIncorporation: countryOfIncorporation,
				companyType: companyType
			}
		}))

		if(appointmentArray.length > 1) {
			showAppointmentSelection();
		} else {
			fillMyInfoAppointment(appointmentArray[0])
		}
	}

	const fillMyInfoAppointment = (appointment) => {
		const appointmentName = appointment["person-reference"]["person-name"].value;
		const appointmentEmail = appointment["corppass-email"]?.value;
		const appointmentMobileNo = appointment["corppass-mobileno"]?.value;
		const nationality = appointment["person-reference"]?.nationality;
		const appointmentTitle = appointment.position;

		setFormValue('appointmentName', appointmentName)
		setFormValue('appointmentEmail', appointmentEmail)
		setFormValue('appointmentMobileNo', appointmentMobileNo)
		setFormValue('nationality', nationality.code)
		setFormValue('appointmentTitle', appointmentTitle?.code)

		setAppointmentInfo(prev => ({
			...prev,
			nationality: nationality.desc,
			appointmentTitle: appointmentTitle?.desc
		}))
		setCurrentMyInfoProfile(prev => ({
			...prev,
			organization: {
				...prev.organization,
				appointmentName: appointmentName ?? "",
				appointmentEmail: appointmentEmail ?? "",
				appointmentMobile: appointmentMobileNo ?? "",
				nationality: nationality,
				appointmentTitle: appointmentTitle
			}
		}))
	}


	const submitHandler = async (data) => {

		const payload = {
			email: data.email.toLowerCase(),
			firstName: data.firstName,
			lastName: data.lastName,
			mobileNumber: data.mobileNo
				? personalInfo.mobileCountryCode.cc + data.mobileNo
				: null,
			org: {
				pitstopName: data.pitstopName,
				pitstopUrl: (pitstopHost?.split('{{SystemShortName}}')[0] + data.pitstopUrl + pitstopHost?.split('{{SystemShortName}}')[1]).toLowerCase(),
				name: data.company,
				uen: data.uen,
				companyType: data.companyType || null,
				incorporationDate: companyInfo.dateOfIncorporation
					? moment
							.parseZone(companyInfo.dateOfIncorporation)
							.utc(true)
							.format()
					: null,
				countryofIncorporation: data.countryOfIncorporation || null,
				registeredAddress: data.registeredAddress || null,
				appointmentName: data.appointmentName || null,
				appointmentNationality: data.nationality || null,
				appointmentEmail: data.appointmentEmail || null,
				appointmentMobile: data.appointmentMobileNo
					? appointmentInfo.mobileCountryCode.cc +
					  data.appointmentMobileNo
					: null,
				enrolmentDataSource: isFilledWithMyInfo ? "MYINFO" : "MANUAL",
				appointmentPosition: data.appointmentTitle || null,
				appointmentIdNumber: appointmentIdSelected || null
			},
		};

		loginHandler(payload)
	}

	function getStartedMyInfo() {
		const redirect_uri = myInfoItem?.authRedirectUrl + `&purpose=MyEnrolmentForm&state=${stateID}&redirect_uri=${baseUrl}/sign-up`;
		window.location = redirect_uri;
	}

	const onResetFormHandler = () => {
		reset({
			companyType: "",
			countryOfIncorporation: "",
			nationality: "",
			appointmentTitle: ""
		});
		setCompanyInfo({
			dateOfIncorporation: null,
		})
		setAppointmentInfo({
			mobileCountryCode: {
				id: "SG",
				label: "SINGAPORE +65",
				cc: "+65"
			},
		})
		setCurrentMyInfoProfile({
			email: "",
			fullName: "",
			mobileNumber: "",
			organization: {}
		})
		setIsFilledWithMyInfo(false);
		setAppointmentIdSelected("")
	}

	const AppointmentRadio = () => {
		const list = myInfoBizAppointmentList.map((item, index) => {
			return (
				<form id="select-appointment-form" key={item["person-reference"].idno.value}>
					<div className="select_appointment_header-list" key={item["person-reference"].idno.value}>
						<div style={{ width: "10%" }}>
							<input type="radio" id={"appointmentName-" + index} name="appointmentName" value={item["person-reference"].idno.value} checked={item["person-reference"].idno.value === appointmentIdSelected}
								className="appointment-radio_class" onClick={(e) => setAppointmentIdSelected(e.target.value)} onChange={() => { }} data-testid="appointment-radio-selected" />
						</div>
						<div style={{ width: "90%" }}>
							<div className='appointment-sourcesystem__radio' >
								<div className="appointment-label_heading appointment-label_heading_bold">
									{item["person-reference"]["person-name"].value}
								</div>
								<div className="appointment-label_heading">
									{item["person-reference"]["nationality"].desc}
								</div>
							</div>
							<div className='appointment-sourcesystem__radio' >
								<div className="appointment-label_heading">
									{item["corppass-email"]?.value ?? 'N/A'}
								</div>
								<div className="appointment-label_heading">
									{item["corppass-mobileno"]?.value ?? 'N/A'}
								</div>
							</div>
							<div className='appointment-sourcesystem__radio' >
								<div className="appointment-label_heading">
									{item["position"].desc}
								</div>
							</div>
						</div>
					</div>
				</form>
			)
		});
		return list;
	}

	return (
		<div className="layout-login__right layout-login__right-buildex">
			<div className="login-box-buildex width-full">
				<div
					className="login-box__title-buildex--header-1"
					data-testid="page-title"
				>
					Sign Up
				</div>
				<div className="login-box__content-buildex">
					<MyinfoBusinessCard
						onMyinfoBusinessClick={showMyInfoConfimModal}
						isFilledWithMyInfo={isFilledWithMyInfo}
						clearForm={onResetFormHandler}
					/>
					<div className="enrolment-form__info-flex">
						<hr />
						<h3 className="enrolment-form__padding">OR</h3>
						<hr />
					</div>
					<form
						className="login-box__form"
						onSubmit={handleSubmit((data) => submitHandler(data))}
						role="form"
					>
						<div className="login-box__form__cols">
							<PersonalInfo
								errors={errors}
								register={register}
								countryCodes={countryCodes}
								personalInfo={personalInfo}
								setPersonalInfo={setPersonalInfo}
								setValue={setValue}
							/>
							<hr />
							<CompanyInfo
								errors={errors}
								register={register}
								watch={watch}
								setValue={setValue}
								infoItems={infoItems}
								companyInfo={companyInfo}
								defaultDomain={defaultDomain}
								setCompanyInfo={setCompanyInfo}
								control={control}
								isFilledWithMyInfo={isFilledWithMyInfo}
								currentProfile={currentMyInfoProfile}
								trigger={trigger}
							/>
							<hr />
							<Appointment
								errors={errors}
								register={register}
								infoItems={infoItems}
								countryCodes={countryCodes}
								appointmentInfo={appointmentInfo}
								setAppointmentInfo={setAppointmentInfo}
								setValue={setValue}
								control={control}
								isFilledWithMyInfo={isFilledWithMyInfo}
								allowAppointmentToggle = {isFilledWithMyInfo && myInfoBizAppointmentList.length > 1}
								showAppointmentSelection={showAppointmentSelection}
								currentProfile={currentMyInfoProfile}
								watch={watch}
							/>

							{isValid && googleKeys?.[dex]?.[env]?.CAPTCHA_SITE_KEY && (
								<ReCAPTCHA
									sitekey={`${googleKeys?.[dex]?.[env]?.CAPTCHA_SITE_KEY}`}
									ref={captchaRef}
									style={{ marginTop: "20px" }}
									onChange={(value) =>
										handleChangeReCaptcha(value)
									}
									onExpired={() => setCaptchaToken(false)}
									size="normal"
									data-testid="recaptcha-test"
								/>
							)}
							{errorMessage && (
								<div className="login-box__form__col--error">
									<Error />{" "}
									<span className="t--required">
										{errorMessage}
									</span>
								</div>
							)}
							<div className="login-box__mandatory-field-text">
								<span>*</span> Mandatory fields.
							</div>
							<div>
								<div className="login-box-buildex__form__actions">
									<Button
										type="submit"
										id="sign-up-submit-trigger-id"
										full
										round
										value="Submit"
										maxWidth="250"
										text="Sign Up"
										disabled={!isValid || !captchaToken}
										loading={loading}
										data-testid="sign-up-submit"
									/>

									<div className="login-box__form__actions__bottom">
										Have an account?{" "}
										<NavLink className="link" to="/login">
											Sign in instead.
										</NavLink>{" "}
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>

			<Portal id="app-blocker">
				{isLoadingMyInfo && (
					<div className="modal white">
						<div className="loading">
							<img src="/loading.gif" alt="Loading" />
						</div>
					</div>
				)}
			</Portal>

			<Modal
				visible={isShowMyInfoModal}
				variant="medium"
				close={hideMyInfoConfirmModal}
				dismissClickOutsideModal={true}
			>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<IconInfoBusiness />
						</CardConfigure.Header.Title>
						<CardConfigure.Header.Close
							onClick={hideMyInfoConfirmModal}
						>
							<IconClose />
						</CardConfigure.Header.Close>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							Pre-fill the enrolment form quickly with Myinfo
							business.
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								text="Cancel"
								ghost
								data-testid="cancel-button"
								noborder
								submit={hideMyInfoConfirmModal}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								full
								maxWidth="140"
								text="Get Started"
								submit={getStartedMyInfo}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal
				visible={visibleAppointmentSelection}
				variant="medium"
				close={hideAppointmentSelection}
				dismissClickOutsideModal={false}
			>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							Select Appointment
						</CardConfigure.Header.Title>
						<CardConfigure.Header.Close
							onClick={hideAppointmentSelection}
						>
							<IconClose />
						</CardConfigure.Header.Close>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="appointment-modal_height">
								<AppointmentRadio />
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								text="Cancel"
								ghost
								data-testid="cancel-button"
								noborder
								submit={hideAppointmentSelection}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								full
								maxWidth="140"
								text="Confirm"
								submit={() => {
									const appointment =
										myInfoBizAppointmentList.find(
											(item) =>
												item["person-reference"].idno
													.value ===
												appointmentIdSelected
										);
									fillMyInfoAppointment(appointment);
									hideAppointmentSelection()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</div>
	);
};

export default BuildexSignup;

BuildexSignup.propTypes = {
	errors: PropTypes.objectOf(
		PropTypes.shape({
			message: PropTypes.string,
		})
	).isRequired,
	register: PropTypes.func.isRequired,
	trigger: PropTypes.func.isRequired,
	setValue: PropTypes.func.isRequired,
	watch: PropTypes.func.isRequired,
	isValid: PropTypes.bool.isRequired,
	loading: PropTypes.bool.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	loginHandler: PropTypes.func.isRequired,
	control: PropTypes.object.isRequired,
	reset: PropTypes.func
};


